class productPersonalization extends HTMLElement {
  constructor() {
    super();
    const tempThis = this;
    this.sectionID = this.getAttribute('section-id');
    this.maxLength = Number(this.getAttribute('max-characters'));

    const inputElems = tempThis.querySelectorAll('input[name="product-personalization"]');
    inputElems.forEach(function(inputElem){
      inputElem.addEventListener('input', (event) => {
        tempThis.writePersonalization(event);
        tempThis.updateFormInput(event);
        tempThis.updateInputMaxLenText(event);
      })
    })
  }

  updateFormInput(triggeredEvent){
    if(triggeredEvent.target.value === ''){
      this.removeFormInput(triggeredEvent.target.id);
    }
    else{
      let inputLine = triggeredEvent.target.value;
      let productFormID = document.querySelector('.product-personalization-block') && document.querySelector('.product-personalization-block').getAttribute('form-id');
      if(productFormID){
        if(document.querySelector('form[id="'+productFormID+'"] input[id="'+triggeredEvent.target.id+'"]')){
          document.querySelector('form[id="'+productFormID+'"] input[id="'+triggeredEvent.target.id+'"]').value = inputLine;
        }
        else{
          let inputNode = document.createElement("input");
          inputNode.type = "hidden";
          inputNode.name = 'properties['+triggeredEvent.target.getAttribute('data-name')+']';
          inputNode.id = triggeredEvent.target.id;
          inputNode.value = inputLine;
          if(document.querySelector('form[id="'+productFormID+'"] #personalization-line-two')){
            document.querySelector('form[id="'+productFormID+'"]').insertBefore(inputNode, document.querySelector('form[id="'+productFormID+'"] #personalization-line-two'));
          }
          else
          document.querySelector('form[id="'+productFormID+'"]').appendChild(inputNode);
        }
      }
    }
  }

  updateInputMaxLenText(triggeredEvent){
    triggeredEvent.target.nextElementSibling? triggeredEvent.target.nextElementSibling.innerHTML = triggeredEvent.target.value.length + '/' + triggeredEvent.target.getAttribute('maxlength'): '';
  }

  removeFormInput(inputID){
    let productFormID = document.querySelector('.product-personalization-block') && document.querySelector('.product-personalization-block').getAttribute('form-id');
    if(productFormID)
    document.querySelector('form[id="'+productFormID+'"] input[id="'+inputID+'"]') && document.querySelector('form[id="'+productFormID+'"] input[id="'+inputID+'"]').remove();
  }

  writePersonalization(event){
    let productGalleryElem = document.querySelector('#MediaGallery-'+this.sectionID+'');
    if(productGalleryElem){
      let validWord = this.validateInput(event);
      if(event.target.id === 'personalization-line-one'){
        this.checkMandatoryInput(validWord);
        productGalleryElem.querySelector('.personalized-lines .first_line') ? productGalleryElem.querySelector('.personalized-lines .first_line').innerHTML = validWord : '';
      }
      else if(event.target.id === 'personalization-line-two'){
        productGalleryElem.querySelector('.personalized-lines .second_line') ? productGalleryElem.querySelector('.personalized-lines .second_line').innerHTML = validWord : '';
      }
    }
  }

  checkMandatoryInput(validWord){
    const productForm = document.getElementById(`product-form-${this.sectionID}`);
    if(document.querySelector(`.personalization-inputs`) && document.querySelector(`.personalization-inputs`).hasAttribute('change-optional')){
      productForm && productForm.querySelector('.product-form__buttons button').removeAttribute('disabled');
    }else if(validWord === ''){
      productForm && productForm.querySelector('.product-form__buttons button').setAttribute('disabled', '');
    }
    else{
      productForm && productForm.querySelector('.product-form__buttons button').removeAttribute('disabled');
    }
  }

  validateInput(triggeredEvent){
    let inputValue = triggeredEvent.target.value;
    
    if (this.maxLength && inputValue.length > this.maxLength) {
        inputValue = inputValue.substring(0, this.maxLength);
    }

    const inputJson = document.querySelector('[personalization-json-data]');
    if(inputJson){
      const blacklistWordsArr = JSON.parse(inputJson.innerHTML).inputBlacklist.split('|');
      let whiteCharacterString = JSON.parse(inputJson.innerHTML).inputWhitelist;
      if (whiteCharacterString.includes('-')) {
        // make sure that the hyphen is always at the end of the string, otherwise it will be treated as a range.
        whiteCharacterString = whiteCharacterString.replace(/-/g, '') + '-';
      }
      const whiteCharacterArr = whiteCharacterString.split('|');
      const allowedCharacters = new RegExp(`^[a-zA-ZÄÖÜäöüß0-9${whiteCharacterArr.join('')}]$`);

      inputValue = inputValue.split('').filter(char => allowedCharacters.test(char)).join(''); // Remove forbidden characters
      blacklistWordsArr.forEach(function(word){// Remove blacklisted words
        const wordRegex = new RegExp(word, 'gi');
        inputValue = inputValue.replace(wordRegex, '');
      });

      triggeredEvent.target.value = inputValue;
    }
    return triggeredEvent.target.value;
  }

}

customElements.define('product-personalization', productPersonalization);
